import { EdgeListUnmatchedQrSignaturesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListUnmatchedQrSignatures } from '@/shared/domain/use-cases'

export function makeListUnmatchedQrSignatures(): ListUnmatchedQrSignatures {
  return new EdgeListUnmatchedQrSignaturesRepository(makeSupabaseEdgeHttpClient()).execute
}
